module.exports = __webpack_public_path__ + "img/bt.7080a396.svg";